import { render, staticRenderFns } from "./Kardex-transfer-list.vue?vue&type=template&id=f50369c4"
import script from "./kardex-transfer-list.js?vue&type=script&lang=js&external"
export * from "./kardex-transfer-list.js?vue&type=script&lang=js&external"
import style0 from "./Kardex-transfer-list.vue?vue&type=style&index=0&id=f50369c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports